import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { View } from '@ilteducation/content-views-types';
import { ContentSection, isContentSections } from '@/types/viewV2';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import { defaultSubscriptions } from '@/foundations/helpers/defaultSubscriptions';
import { defaultRealms } from '@/foundations/helpers/defaultRealms';
import useMediaFormFeature from '@/comp/use-media-form-feature';
import ViewsConfigurator from '@/components/view/ViewsConfigurator.vue';
import ViewsConfiguratorV2Field from '@/components/view/v2/ViewsConfiguratorV2Field.vue';

type Props = {
  id?: string;
  title: string;
  item?: View;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: View;
}


const availableMarkets = ref(defaultRealms);
const availableSubscriptions = ref(defaultSubscriptions);
const isFormEdited = ref(false);

const requiredMultiple = ref((value: unknown[]) => value?.length > 0 || 'This field is required');

const { uploadMedia, saveButtonAvailable, isCloneMode } = useMediaFormFeature(props.item as any);
// View type selection
const isV2 = ref<boolean>((props.item as any)?.type === 'Content');

const sections = ref(props.item?.sections ?? []);

const sections1 = ref<ContentSection[] | undefined>(
  props.item && isContentSections(props.item?.sections) ? props.item?.sections : undefined,
);

const realm = ref<string>(
  (props.item as any)?.realm ? defaultRealms.find((r) => r.code === (props.item as any)?.realm)?.realm ?? '?' : '?',
);
const key = ref((props.item as any)?.key);

return { __sfc: true,props, availableMarkets, availableSubscriptions, isFormEdited, requiredMultiple, uploadMedia, saveButtonAvailable, isCloneMode, isV2, sections, sections1, realm, key, DisableableButton, ViewsConfigurator, ViewsConfiguratorV2Field }
}

})